import { apiClient } from '@/libs/api'
import { type PageEntity, type TruckListExEntity } from '@/libs/api'
import { type TrucksRequestQuery } from '@/libs/api/types'

export type FetchTrucksListQuery = {
  tenantKey: string
  query?: TrucksRequestQuery
}

export type FetchTrucksListResponse = {
  data: TruckListExEntity[]
  pagination: PageEntity | null
}

// 車両一覧用 車両マスタ取得API
export const fetchTrucksList = async (
  { tenantKey, query }: FetchTrucksListQuery,
  signal?: AbortSignal
): Promise<FetchTrucksListResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .trucks.list.$get({
      query,
      config: {
        signal
      }
    })
  return { data, pagination }
}
